import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tag, Percent, Coins, Wallet, Sparkles, Clock } from "lucide-react";
import { REWARD_LABELS } from "@/lib/promoEngine";

const ICON = {
  percent_off: Percent,
  fixed_off: Coins,
  cashback: Wallet,
};

const formatWindow = (p) => {
  if (!p.ends_at) return null;
  const end = new Date(p.ends_at);
  const now = new Date();
  const ms = end - now;
  if (ms <= 0) return null;
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  if (days > 0) return `${days}g ${hours}h`;
  if (hours > 0) return `${hours}h`;
  return "in scadenza";
};

const formatTrigger = (p) => {
  const t = [];
  if (p.brand) t.push(p.brand);
  if (p.category) t.push(p.category);
  if (p.min_quantity) t.push(`${p.min_quantity}+ pz`);
  if (p.min_amount) t.push(`spesa ≥ €${p.min_amount}`);
  return t.join(" · ");
};

export const PromoBanner = () => {
  const [promos, setPromos] = useState([]);
  useEffect(() => {
    api.get("/promotions/active")
      .then(({ data }) => setPromos(data || []))
      .catch(() => setPromos([]));
  }, []);

  if (!promos.length) return null;

  // Duplicate array for seamless marquee scrolling
  const loop = [...promos, ...promos];

  return (
    <section className="border-t border-b border-[#D4AF37]/30 bg-gradient-to-r from-[#0A0A0A] via-[#141414] to-[#0A0A0A] overflow-hidden py-8" data-testid="promo-banner">
      <div className="max-w-7xl mx-auto px-6 mb-4 flex items-center gap-2">
        <Sparkles className="w-4 h-4 text-[#D4AF37]" />
        <div className="font-overline text-[10px] text-[#D4AF37]">— PROMO ATTIVE</div>
      </div>
      <div className="relative">
        <div className="flex animate-marquee whitespace-nowrap" style={{ animationDuration: `${Math.max(20, promos.length * 8)}s` }}>
          {loop.map((p, idx) => {
            const Icon = ICON[p.reward_type] || Tag;
            const window_text = formatWindow(p);
            const trigger_text = formatTrigger(p);
            return (
              <div
                key={`${p.promo_id}-${idx}`}
                className="inline-flex items-stretch mx-3 border border-[#D4AF37]/50 bg-black/60 backdrop-blur-sm min-w-[320px]"
                data-testid={`promo-banner-card-${p.promo_id}`}
              >
                {/* Reward tab */}
                <div className="flex flex-col items-center justify-center px-5 py-4 bg-[#D4AF37]/15 border-r border-[#D4AF37]/40">
                  <Icon className="w-5 h-5 text-[#D4AF37] mb-1" />
                  <div className="font-display font-black text-2xl text-[#D4AF37] leading-none">
                    {(REWARD_LABELS[p.reward_type] || ((v) => v))(p.reward_value)}
                  </div>
                </div>
                {/* Text */}
                <div className="flex-1 px-4 py-3 min-w-0">
                  <div className="text-sm font-bold text-white truncate max-w-[220px]">{p.name}</div>
                  {trigger_text && (
                    <div className="text-[10px] text-neutral-400 truncate max-w-[220px]">
                      Trigger: {trigger_text}
                    </div>
                  )}
                  {window_text && (
                    <div className="flex items-center gap-1 mt-1 text-[10px] text-[#D4AF37]">
                      <Clock className="w-2.5 h-2.5" /> scade tra {window_text}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
